import { t } from "../../../../../utils/i18n";
import countries from "../../../../../utils/countries.json";
import countriesPhoneCodes from "../../../../../utils/countryPhoneCodes.json";
export const titleOptions = () => [
  {
    value: "Mr.",
    label: t("cards.request_form.title_mr"),
  },

  {
    value: "Mrs.",
    label: t("cards.request_form.title_mrs"),
  },
  {
    value: "Ms.",
    label: t("cards.request_form.title_ms"),
  },
];

export const genderOptions = () => [
  {
    value: "male",
    label: t("cards.request_form.gender_male"),
  },
  {
    value: "female",
    label: t("cards.request_form.gender_female"),
  },
];

export const maritalOptions = () => [
  {
    value: "single",
    label: t("cards.request_form.marital_single"),
  },
  {
    value: "married",
    label: t("cards.request_form.marital_married"),
  },
];

export const idTypeOptions = () => [
  {
    value: "passport",
    label: t("cards.request_form.id_type_passport"),
  },
];

export const cardNetworkOptions = [
  {
    value: "visa",
    label: "Visa",
  },
];

export const countryOptions = countries
  .map((country) => {
    return {
      value: country.code2,
      label: country.name,
    };
  });

export const dialingCodeOptions = countriesPhoneCodes
  .map((country) => {
    return {
      value: `+${country.code}`,
      label: `+${country.code} (${country.country})`
    }
  });

let indexOfStepUpper = 0;
export const canNavigate = (currentStep, step) => {
  let allSteps = ["personal", "identification", "mailing", "preview"]
  let currentStepIndex = allSteps.indexOf(currentStep)
  if(currentStepIndex >= indexOfStepUpper){
    indexOfStepUpper = currentStepIndex
  }
  let targetStepIndex = allSteps.indexOf(step)
  return targetStepIndex <= indexOfStepUpper
}

export const isCompleted = (currentStep, step) => {
  let allSteps = ["personal", "identification", "mailing", "preview"]
  let currentStepIndex = allSteps.indexOf(currentStep)
  let targetStepIndex = allSteps.indexOf(step)
  return targetStepIndex < currentStepIndex
}